import type { ColDef } from 'ag-grid-enterprise';

import {
  renderCvssScore,
  renderPonduranceScore
} from './AssetVulnerabilitiesTable.utils';

export const ASSET_VULNERABILITIES_TABLE_COLUMNS: ColDef[] = [
  {
    field: 'name',
    headerName: 'Vulnerability Name',
    flex: 1,
    cellClass: 'cell-ellipsis'
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 3,
    wrapText: true,
    autoHeight: true,
    cellStyle: {
      lineHeight: '1.4rem',
      padding: '0.25rem 0'
    }
  },

  {
    field: 'cvss',
    headerName: 'CVSS Score',
    width: 150,
    initialSort: 'desc',
    cellRenderer: renderCvssScore
  },
  {
    field: 'vmp_exposure_index',
    headerName: 'Pondurance Score',
    width: 200,
    cellRenderer: renderPonduranceScore
  }
  // TODO: we should display this useful column, but has to be done everywhere
  // {
  //   field: 'category',
  //   headerName: 'Category',
  //   flex: 1
  // }
];

export default ASSET_VULNERABILITIES_TABLE_COLUMNS;
